import axios from 'axios';

const API_URL = '/api'; //'http://localhost:8002/api'

export const authService = {
    getAuthCode: async () => {
        try {
            const response = await axios.get(`${API_URL}/auth/code`);
            return response.data;
        } catch (error) {
            console.error('Auth API Error:', {
                status: error.response?.status,
                data: error.response?.data,
                message: error.message
            });
            throw error;
        }
    },

    checkAuthStatus: async (code) => {
        try {
            const response = await axios.get(`${API_URL}/auth/status/${code}`);
            return response.data;
        } catch (error) {
            console.error('Auth Status API Error:', {
                status: error.response?.status,
                data: error.response?.data,
                message: error.message
            });
            throw error;
        }
    },

    verifyCode: async (code, slack_id) => {
        try {
            const response = await axios.post(`${API_URL}/auth/verify`, {
                code,
                slack_id
            });
            return response.data;
        } catch (error) {
            console.error('Auth Verify API Error:', {
                status: error.response?.status,
                data: error.response?.data,
                message: error.message
            });
            throw error;
        }
    },

    validateToken: async (token) => {
        try {
            const response = await axios.get(`${API_URL}/auth/validate`, {
                params: { token }
            });
            return response.data;
        } catch (error) {
            console.error('Token Validation API Error:', {
                status: error.response?.status,
                data: error.response?.data,
                message: error.message
            });
            throw error;
        }
    }
};